import React from "react";

const Loader = () => {
  return (
    <div className="h-full w-100 z-cc fixed top-0 right-0 left-0 d-flex justify-content-center align-items-center bg-cc">
      <div className="spinner-grow text-warning" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

export const Loading = ({ height = "200px", overlay = true, message = "Loading...", style }) => {
  return (
    <div
      className="position-relative w-100"
      style={{ height, ...style }}
    >
      {/* Overlay */}
      <div
        className={`
          position-absolute top-0 start-0 w-100 h-100
          d-flex justify-content-center align-items-center
          ${overlay ? "bg-opacity-75" : ""}
        `}
        style={{ zIndex: 10 }}
      >
        <div className="spinner-border text-secondary" role="status">
          <span className="visually-hidden">{message}</span>
        </div>
      </div>
    </div>
  );
};


export default Loader;
